module.exports = __webpack_public_path__ + "static/media/avatar_bg_2.3a721873.png";